import { useEffect } from "react";

type SeoHeadProps = {
  title: string;
  description: string;
  /** Relative path, e.g. "/mcp/linear-mcp" */
  canonical?: string;
  /** Absolute URL or relative path to OG image (PNG/JPG — SVG not supported by Twitter/Slack) */
  image?: string;
};

const BASE_URL = "https://apitomcpconverter.com";
const DEFAULT_IMAGE = `${BASE_URL}/favicon-512x512.png`;

export default function SeoHead({ title, description, canonical, image }: SeoHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (prop: string, content: string, attr = "property") => {
      let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, prop);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    // Description
    setMeta("description", description, "name");

    // Canonical
    let canonEl = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) {
      if (!canonEl) {
        canonEl = document.createElement("link");
        canonEl.rel = "canonical";
        document.head.appendChild(canonEl);
      }
      canonEl.href = `${BASE_URL}${canonical}`;
    }

    // OG
    const ogImage = image
      ? image.startsWith("http") ? image : `${BASE_URL}${image}`
      : DEFAULT_IMAGE;

    setMeta("og:title", title);
    setMeta("og:description", description);
    setMeta("og:image", ogImage);
    if (canonical) setMeta("og:url", `${BASE_URL}${canonical}`);

    // Twitter
    setMeta("twitter:title", title, "name");
    setMeta("twitter:description", description, "name");
    setMeta("twitter:image", ogImage, "name");

    return () => {
      document.title = "API to MCP Converter | Convert OpenAPI & REST APIs to MCP";
    };
  }, [title, description, canonical, image]);

  return null;
}
